<template lang="pug">
  .user-card
    .user-card__container
      .user-card__main
        a.user-card__img(
          :href="link"
          target="_blank"
          rel="noopener noreferrer"
        )
          slot(name="img")
          avatar(
            v-if="!$scopedSlots.img"
            :username="name"
            :img="avatar"
            :size="58"
          )
        .user-card__info
          a.link.link_inherit.text-lg(
            :href="link"
            target="_blank"
            rel="noopener noreferrer"
            v-html="name"
          )
          .text-md.user-card__info-text(
            v-if="!$scopedSlots.details"
            v-html="details"
          )
          slot(name="details")
      .user-card__actions(v-if="$scopedSlots.actions")
        slot(name="actions")
</template>

<script>
import Avatar from '@/components/Avatar.vue'

export default {
  name: 'UserCard',
  components: {
    Avatar
  },
  props: {
    name: String,
    details: String,
    avatar: String,
    link: String
  }
}
</script>

<style lang="scss" scoped>
  @import "@/assets/scss/clubs";

  .user-card {
    background-color: $color-primary-1;
    border-radius: 2px;

    &__container {
      display: flex;
      align-items: center;
      padding: 12px 16px;

      @media (max-width: breakpoint(md, max)) {
        flex-direction: column;
        gap: 24px;
        padding: 16px;
      }
    }

    &__main {
      display: flex;
      align-items: center;
      flex: 1 1 auto;

      @media (max-width: breakpoint(md, max)) {
        flex-direction: column;
        gap: 12px;
        text-align: center;
      }
    }

    &__img {
      flex: 0 0 auto;
      margin-right: 16px;
      text-decoration: none;

      @media (max-width: breakpoint(md, max)) {
        margin-right: 0;
      }
    }

    &__actions {
      flex: 0 0 auto;

      @media (min-width: breakpoint(md)) {
        margin: 0 0 0 16px;
      }
    }

    &__info {
      &-text {
        margin-top: 4px;
      }
    }
  }
</style>
